/**
 * Hardcoded dashboard report templates organized by operational role.
 *
 * Each template defines a set of SavedReport configurations that can be
 * bulk-created via the existing API_save_report endpoint.
 *
 * Reports with scope: "per_store" generate one report per selected store.
 * Some templates also place these reports into per-store tabs.
 * Reports without a scope (or scope: "aggregate") create one report
 * containing all selected stores.
 */

export const TEMPLATE_ROLES = [
  { key: "general_manager", label: "All Locations", isMultiStore: false },
  { key: "district_manager", label: "Each Location", isMultiStore: true },
];

const OPERATIONS_OVERVIEW_REPORTS = [
  {
    name: "Sales vs Previous Year (Sales Improving?)",
    selected_metrics: ["actual_sales", "actual_sales_previous_year"],
    selected_date_range: "current_quarter_to_date",
    active_tab: "Daily",
    selected_radio_option: "Compare by Metric",
    widget_type: "line",
  },
  {
    name: "SPLH vs Previous Year (SPLH Improving?)",
    selected_metrics: ["splh"],
    selected_date_range: "current_quarter_to_date",
    active_tab: "Daily",
    selected_radio_option: "Compare to Previous Year",
    widget_type: "line",
  },
  {
    name: "Intraday Sales vs Forecasted (Accurate Forecasting?)",
    selected_metrics: ["actual_sales", "forecasted_sales"],
    selected_date_range: "current_quarter_to_date",
    active_tab: "Intraday",
    selected_radio_option: "Compare by Metric",
    widget_type: "line",
  },
  {
    name: "Intraday Hours vs Earned (Over/Under Staffed?)",
    selected_metrics: ["actual_labor_hours", "earned_labor_hours"],
    selected_date_range: "current_quarter_to_date",
    active_tab: "Intraday",
    selected_radio_option: "Compare by Metric",
    widget_type: "line",
  },
  {
    name: "Forecast Accuracy (Correctly Adjusting?)",
    selected_metrics: [
      "actual_to_forecasted_sales",
      "actual_to_forecasted_adjusted_sales",
    ],
    selected_date_range: "current_quarter_to_date",
    active_tab: "Daily",
    selected_radio_option: "Compare by Metric",
    widget_type: "cards",
  },
  {
    name: "Scheduled vs Forecasted (Following Recs?)",
    selected_metrics: ["scheduled_to_forecasted_hours"],
    selected_date_range: "current_quarter_to_date",
    active_tab: "Daily",
    selected_radio_option: "Default",
    widget_type: "line",
  },
  {
    name: "Actual vs Scheduled (Executing Plan?)",
    selected_metrics: ["actual_to_scheduled_hours"],
    selected_date_range: "current_quarter_to_date",
    active_tab: "Daily",
    selected_radio_option: "Default",
    widget_type: "line",
  },
  {
    name: "Actual vs Earned (Meeting Targets?)",
    selected_metrics: ["actual_to_earned_hours"],
    selected_date_range: "current_quarter_to_date",
    active_tab: "Daily",
    selected_radio_option: "Default",
    widget_type: "line",
  },
];

export const REPORT_TEMPLATES = [
  // ── General Manager ───────────────────────────────────────────────
  {
    id: "gm_daily_ops",
    name: "Operations Overview",
    description:
      "Track sales, labor, and efficiency over the current quarter, aggregated across all locations.",
    roles: ["general_manager"],
    tabName: null,
    reports: OPERATIONS_OVERVIEW_REPORTS,
  },

  // ── Operations Leader ─────────────────────────────────────────────
  {
    id: "dm_multi_store_weekly",
    name: "Per Store Operations Review",
    description:
      "Track sales, labor, and efficiency over the current quarter, one set of reports for each location.",
    roles: ["district_manager"],
    tabName: null,
    createStoreTabs: true,
    reports: OPERATIONS_OVERVIEW_REPORTS.map((report) => ({
      ...report,
      scope: "per_store",
    })),
  },
];
